export const FAMILY_CREATED_SUCCESS = "Family Created Successfully";
export const FAMILY_JOIN_SUCCESS = "Join request send to Family admin. please wait until he approves";
export const MEMBER_ADDED_TO_FAMILY_SUCCESS = "Member added successfully";
export const APPROVE_REQUEST = "Request approved successfully";
export const REJECT_REQUEST = "Request rejected successfully";
export const ADD_QUESTION_SUCCESS = "Question added successfully";
export const DELETE_QUESTION_SUCCESS = "Question deleted successfully";
export const UPDATE_QUESTION_SUCCESS = "Question updated successfully";
export const QUIZ_CREATED_SUCCESS = "Quiz created successfully";